<template>
  <div class="m-contain" @mousewheel="wheelScroll">
    <a-carousel dot-position="right" autoplay ref="carouselRef" :after-change="afterChange">
      <!-- 全品类产品研究 autoplay-->
      <div>
        <div class="page-content">
          <div class="top-title animate__animated" :class="activeIndex===0?'animate__bounceInLeft':''">
            <label>全品类产品研究</label> 
            <div class="line"></div>
          </div>
          
          <div class="top-info " :class="activeIndex===0?'opticy-full animate__animated animate__zoomInRight':'opticy-none'">
            公募基金10000+、私募基金70000+、银行理财30000+、保险、宏观、行业
          </div>
          <div class="bottom-info" :class="activeIndex===0?'animate__animated animate__lightSpeedInRight':''" >
            <ul class="type-icon">
              <li>
                <i class="type1"></i>
                <p>公募基金</p>
              </li>
              <li>
                <i class="type2"></i>
                <p>私募基金</p>
              </li>
              <li>
                <i class="type3"></i>
                <p>银行理财</p>
              </li>
              <li>
                <i class="type4"></i>
                <p>保险</p>
              </li>
              <li>
                <i class="type5"></i>
                <p>宏观行业</p>
              </li>
            </ul>
          </div>
          <div class="bottom-btn">
            <div class="soon-touch"></div>
            <!-- <a-button type="primary" class="soon-touch"  @click="goTo">
              <label class="touch-font">立即体验 >></label>
            </a-button> -->
          </div>
        </div>
      </div>
      <!-- 全品类产品研究 autoplay-->
      <div>
        <div class="page-content">
          <div class="top-title" :class="activeIndex===1?'opticy-full animate__animated animate__bounceInLeft':'opticy-none'">
            <label>深耕财富场景</label> 
            <div class="line"></div>
          </div>
          <div class="bottom-scene">
            <ul class="scene-icon" :class="activeIndex===1?'opticy-full animate__animated animate__lightSpeedInRight':'opticy-none'">
              <li class="li-bg1">
                <p class="scene-font scene-color1">资产配置</p>
                <p class="scene-color1">面向高端财管</p>
                <i class="scene-img1"></i>
              </li>
              <li class="li-bg2">
                <p class="scene-font scene-color2">公募投顾</p>
                <p class="scene-color2">面向长尾客群</p>
                <i class="scene-img2"></i>
              </li>
              <li class="li-bg3">
                <p class="scene-font scene-color3">机构理财</p>
                <p class="scene-color3">面向专业投资者</p>
                <i class="scene-img3"></i>
              </li>
              <li class="li-bg4">
                <p class="scene-font scene-color4">产品中心</p>
                <p class="scene-color4">面向金融机构内部管理</p>
                <i class="scene-img4"></i>
              </li>
            </ul>
          </div>
          <div class="bottom-btn">
            <div class="soon-touch"></div>
            <!-- <a-button type="primary" class="soon-touch">
              <label class="touch-font">立即体验 >></label>
            </a-button> -->
          </div>
        </div>
      </div>
      <!-- 多策略深度分析 -->
      <div>
        <div class="page-content">
          <div class="analysis">
            <div class="analysis-left">
              <div  class="top-title" :class="activeIndex===2?'opticy-full animate__animated animate__bounceInLeft':'opticy-none'">
                <label for="">多策略深度分析</label> 
                <div class="line"></div>
              </div>
              <div class="info-text" :class="activeIndex===2?'opticy-full animate__animated animate__zoomInRight':'opticy-none'">
                可转债、港股、FOF、指增、量化、固收、指增、对冲等多策略帮助您进行深度分析
              </div>
            </div>
            <div class="analysis-right" :class="activeIndex===2?'opticy-full animate__animated animate__lightSpeedInRight':'opticy-none'">
              <div class="right-img"></div>
            </div>
          </div>
          <div class="bottom-btn">
            <div class="soon-touch"></div>
            <!-- <a-button type="primary" class="soon-touch">
              <label class="touch-font">立即体验 >></label>
            </a-button> -->
          </div>
        </div>
      </div>
      <!-- 财富管理解决方案 -->
      <div>
        <div class="page-content">
          <div class="analysis">
            <div class="analysis-right"  :class="activeIndex===3?'opticy-full animate__animated animate__bounceInLeft':'opticy-none'">
              <div class="plan-img"></div>
            </div>
            <div class="analysis-left">
              <div  class="top-title" :class="activeIndex===3?'opticy-full animate__animated animate__zoomInRight':'opticy-none'">
                <label for="">财富管理解决方案</label> 
                <div class="line"></div>
              </div>
              <div class="info-text"  :class="activeIndex===3?'opticy-full animate__animated animate__lightSpeedInRight':'opticy-none'">
                以产品研究为基石，通过机构理财、公募投顾、资产配置等模块功能为您的财富管理提供解决方案
              </div>
            </div>
          </div>
          <div class="bottom-btn">
            <div class="soon-touch"></div>
            <!-- <a-button type="primary" class="soon-touch">
              <label class="touch-font">立即体验 >></label>
            </a-button> -->
          </div>
        </div>
      </div>
      <!-- 投顾服务中台 -->
      <div>
        <div class="page-content">
          <div class="analysis">
            <div class="analysis-left">
              <div class="top-title" :class="activeIndex===4?'opticy-full animate__animated animate__bounceInLeft':'opticy-none'">
                <label for="">投顾服务中台</label> 
                <div class="line"></div>
              </div>
              <div class="info-text" :class="activeIndex===4?'opticy-full animate__animated animate__zoomInRight':'opticy-none'">
                选基神器、基金标签、资产配置、产品画像等均支持H5组件助力投顾服务
              </div>
            </div>
            <div class="analysis-right"  :class="activeIndex===4?'opticy-full animate__animated animate__lightSpeedInRight':'opticy-none'">
              <div class="service-img"></div>
            </div>
          </div>
          <div class="bottom-btn">
            <div class="soon-touch"></div>
            <!-- <a-button type="primary" class="soon-touch">
              <label class="touch-font">立即体验 >></label>
            </a-button> -->
          </div>
        </div>
      </div>
    </a-carousel>
  </div>
</template>
<script>
/* 中部内容 */
export default {
  name: 'MiddleContent',
  components: {
  },
  props: {},
  watch: {},
  data() {
    return {
      activeIndex: 0
    };
  },
  computed: {},
  created() {
  },
  methods: {
    wheelScroll(e) {
      if (e.wheelDeltaY < 0) {
        this.$refs.carouselRef.next();
      } else {
        this.$refs.carouselRef.prev();
      }
    },
    goTo(wheelDeltaY) {
      console.log('wheelDeltaY', wheelDeltaY);
    },
    afterChange(curr) {
      console.log('curr', curr);
      this.activeIndex = curr;
    }
  }
};
</script>

<style lang='less' scoped>
.m-contain {
  max-width: 1440px;
  min-width: 1280px;
  .page-content {
    padding: 8vh 0;
    width: 100%;
    height: calc(84vh - 72px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    //全品类产品研究
    .top-title {
      font-size: 44px;
      font-family: DingTalk-JinBuTi;
      font-weight: 400;
      color: #4686F2;
      .line {
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 2%;
        width: 387px;
        height: 2px;
        background: linear-gradient(90deg, rgba(70,134,242,0) 0%, #4686F2 50%, rgba(70,134,242,0) 100%);
      }
    }
    .top-info {
      padding-bottom: 3%;
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 600;
      color: #3D3D3D;
    }
    .bottom-info {
      display: inline-block;
      min-width: 1000px;
      padding-bottom: 1%;
      .type-icon {
        display: flex;
        justify-content: space-between;
        li {
          padding-top: 20px;
          width: 160px;
          height: 160px;
          background: #FFFFFF;
          box-shadow: 12px 12px 60px 0px rgba(0,0,0,0.08);
          border-radius: 8px 8px 8px 8px;
          i {
            display: inline-block;
            width: 80px;
            height: 80px;
          }
          p {
            font-size: 18px;
            color: #000;
            font-weight: 600;
          }
          .type1 {
            background: url(~@/assets/pro-type1.png);
            background-size: 100% 100%;
          }
          .type2 {
            background: url(~@/assets/pro-type2.png);
            background-size: 100% 100%;
          }
          .type3 {
            background: url(~@/assets/pro-type3.png);
            background-size: 100% 100%;
          }
          .type4 {
            background: url(~@/assets/pro-type4.png);
            background-size: 100% 100%;
          }
          .type5 {
            background: url(~@/assets/pro-type5.png);
            background-size: 100% 100%;
          }
        }
      }
    }
    .bottom-btn {
      padding-bottom: 1%;
      .soon-touch {
        width: 194px;
        height: 52px;
        .touch-font {
          font-size: 18px;
          font-family: DingTalk-JinBuTi;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
    // 财富场景
    .bottom-scene {
      display: inline-block;
      min-width: 1020px;
      padding-top: 1%;
      .scene-icon {
        display: flex;
        justify-content: space-between;
        li {
          position: relative;
          width: 240px;
          height: 288px;
          box-shadow: 12px 12px 60px 0px rgba(0,0,0,0.08);
          border-radius: 8px 8px 8px 8px;
          text-align: left;
          padding: 10px 0 0 10px;
          .scene-font {
            font-size: 24px;
            font-family: DingTalk-JinBuTi;
            font-weight: 400;
          }
          p {
            margin-bottom: 0;
            font-size: 14px;
          }
          i {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 120px;
            height: 200px;
          }
          .scene-color1 {
            color: #4686F2;
          }
          .scene-color2 {
            color: #1B66A0;
          }
          .scene-color3 {
            color: #6047A2;
          }
          .scene-color4 {
            color: #0B996A ;
          }
          .scene-img1 {
            background: url(~@/assets/scene1.png);
            background-size: 100% 100%;
          }
          .scene-img2 {
            background: url(~@/assets/scene2.png);
            background-size: 100% 100%;
          }
          .scene-img3 {
            background: url(~@/assets/scene3.png);
            background-size: 100% 100%;
          }
          .scene-img4 {
            background: url(~@/assets/scene4.png);
            background-size: 100% 100%;
          }
        }
        .li-bg1 {
          background: linear-gradient(180deg, rgba(70,134,242,0.2) 0%, rgba(255,255,255,0) 100%);
        }
        .li-bg2 {
          background: #FFFFFF linear-gradient(180deg, #CAEFF9 0%, rgba(70,134,242,0.46) 0%, rgba(70,134,242,0.18) 0%, rgba(255,255,255,0.22) 100%);
        }
        .li-bg3 {
          background: linear-gradient(180deg, rgba(180,153,252,0.2) 0%, rgba(255,255,255,0) 100%);
        }
        .li-bg4 {
          background: linear-gradient(180deg, rgba(11,153,106,0.2) 0%, rgba(255,255,255,0) 100%);
        }
      }
    }
    // 多策略深度分析
    .analysis {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0 14%;
      width: 100%;
      .analysis-left {
        padding-top: 6%;
        text-align: left;
        .top-title {
          font-size: 44px;
          font-family: DingTalk-JinBuTi;
          font-weight: 400;
          color: #4686F2;
          .line {
            margin-left: 41%;
            margin-top: 2%;
            width: 387px;
            height: 2px;
            background: linear-gradient(90deg, #4686F2 0%, rgba(70, 134, 242, 0) 100%);
          }
        }
        .info-text {
          margin-top: 20px;
          width: 481px;
          height: 68px;
          white-space: pre-wrap;
          font-size: 18px;
          font-weight: 400;
          color: #333333;
        }
      }
      .analysis-right {
        .right-img {
          width: 339px;
          height: 316px;
          background: url(~@/assets/analysis-right.png);
          background-size: 100% 100%;
        }
        .plan-img {
          width: 339px;
          height: 316px;
          background: url(~@/assets/plan-img.png);
          background-size: 100% 100%;
        }
        .service-img {
          width: 339px;
          height: 316px;
          background: url(~@/assets/service-img.png);
          background-size: 100% 100%;
        }
      }
    }
  }
  .ant-carousel /deep/ .slick-slide {
    text-align: center;
    height: calc(84vh - 72px);
    background: #F5F7FC;
    overflow: hidden;
  }
  .ant-carousel /deep/ .slick-dots li button {
    background: rgba(70, 134, 242, 0.7);
  }
  .ant-carousel /deep/ .slick-dots li.slick-active button {
    background: #4686F2;
  }
  .ant-carousel-vertical /deep/ .slick-dots-right {
    right: 4%;
  }
}
</style>